import { useGetList, type Identifier } from "ra-core";

import { getSupabaseClient } from "../../providers/supabase/supabase";
import type { Commission, CommissionStatus } from "./commissions";

const rpc = async <T>(name: string, args: Record<string, unknown>) => {
  const { data, error } = await getSupabaseClient().rpc(name, args);
  if (error) throw new Error(error.message);
  return data as T;
};

/** The ledger of one month (the database shows each person only their own). */
export const useCommissions = (month: string) =>
  useGetList<Commission>("gula_commissions_summary", {
    filter: { month },
    pagination: { page: 1, perPage: 2000 },
    sort: { field: "day", order: "DESC" },
  });

export const setCommissionStatus = (
  id: Identifier,
  status: CommissionStatus,
  note?: string,
) =>
  rpc<void>("gula_commission_set", {
    p_id: Number(id),
    p_status: status,
    p_note: note ?? null,
  });

export const addCommission = (
  salesId: Identifier,
  amount: number,
  note: string,
  clientId?: Identifier | null,
) =>
  rpc<number>("gula_commission_add", {
    p_sales_id: Number(salesId),
    p_amount: amount,
    p_note: note,
    p_client_id: clientId == null ? null : Number(clientId),
  });
